import {inject, observer} from "mobx-react";
import React from "react";
import {Location} from "@src/Interfaces/Entity/Location";
import {IValuesStore} from "Stores/Values/types";
import {IManagementStore} from "Stores/Management/types";
import {RegenerateSecrets} from "./RegenerateSecrets/RegenerateSecrets";
import {observable} from "mobx";
import {DeploymentInstructions} from "./DeploymentInstructions/DeploymentInstructions";

interface IDeployOnBareMetalTabProps {
  location: Location;
  values?: IValuesStore;
  management?: IManagementStore;
}

@inject("values", "management")
@observer
export class DeployOnBareMetalTab extends React.Component<IDeployOnBareMetalTabProps> {
  @observable isLocationDeploymentVariablesDownloaded: boolean = false;

  componentDidMount() {
    this.isLocationDeploymentVariablesDownloaded = this.props.location.isLocationDeploymentVariablesDownloaded;
  }

  async handleResetLocationSecrets() {
    await this.props.management.clearLocationSecrets(this.props.location.id);
    this.isLocationDeploymentVariablesDownloaded = false;
  }

  render() {
    return (
      <>
        {this.isLocationDeploymentVariablesDownloaded ? (
          <RegenerateSecrets
            handleResetLocationSecrets={this.handleResetLocationSecrets.bind(this)}
          />
        ) : (
          <DeploymentInstructions
            location={this.props.location}
          />
        )}
      </>
    );
  }
}